import { render, staticRenderFns } from "./JsonCSV.vue?vue&type=template&id=0c8b069f&scoped=true"
import script from "./JsonCSV.vue?vue&type=script&lang=js"
export * from "./JsonCSV.vue?vue&type=script&lang=js"
import style0 from "./JsonCSV.vue?vue&type=style&index=0&id=0c8b069f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b069f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8b069f')) {
      api.createRecord('0c8b069f', component.options)
    } else {
      api.reload('0c8b069f', component.options)
    }
    module.hot.accept("./JsonCSV.vue?vue&type=template&id=0c8b069f&scoped=true", function () {
      api.rerender('0c8b069f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/vue-json-csv/JsonCSV.vue"
export default component.exports